import React from 'react';
const painPoints = [{
  bold: 'El dinero se evapora:',
  text: 'Sentís que trabajás todo el día (en casa o afuera) y la plata nunca alcanza para darles gustos a tus hijos o proyectar a futuro. 🧾'
}, {
  bold: 'Miedo a "quemar" ahorros:',
  text: 'Te aterra invertir en insumos, que nadie compre y terminar perdiendo lo poco que tenías guardado. 😰'
}, {
  bold: 'Culpa constante:',
  text: 'Si trabajás fuera, extrañás a tus hijos. Si estás en casa, sentís culpa por no generar ingresos propios. Es un callejón sin salida. 💔'
}, {
  bold: 'Cansada de improvisar:',
  text: 'Vendés a ojo, cocinás cuando podés y al final del mes te das cuenta de que trabajaste gratis porque calculaste mal los precios. 🚫'
}];
export function RealitySection() {
  return <section className="w-full bg-[#f0efe9] px-4 md:px-8 pt-10 pb-10" data-id="element-298">
      <div className="max-w-[900px] mx-auto" data-id="element-299">
        {/* Card */}
        <div className="bg-white rounded-2xl shadow-[0_2px_16px_rgba(0,0,0,0.06)] overflow-hidden" data-id="element-300">
          {/* Header */}
          <div className="text-center py-6 px-6 border-b border-gray-100" data-id="element-301">
            <h2 className="font-['Playfair_Display',_serif] text-2xl md:text-3xl lg:text-[34px] font-bold text-[#1a1a1a]" data-id="element-302">
              ❗ La realidad de muchas madres hoy...
            </h2>
          </div>

          {/* Pain Points */}
          <div className="px-6 md:px-10 py-8 space-y-7" data-id="element-303">
            {painPoints.map((point, index) => <div key={index} className="flex items-start gap-4" data-id="element-304">
                {/* Red X icon */}
                <div className="flex-shrink-0 mt-1" data-id="element-305">
                  <div className="w-7 h-7 rounded-full bg-[#c0392b] flex items-center justify-center" data-id="element-306">
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" data-id="element-307">
                      <path d="M3.5 3.5L10.5 10.5M10.5 3.5L3.5 10.5" stroke="white" strokeWidth="2" strokeLinecap="round" data-id="element-308" />
                    </svg>
                  </div>
                </div>
                {/* Text */}
                <p className="text-[#374151] text-base md:text-lg lg:text-[19px] leading-relaxed" data-id="element-309">
                  <span className="font-bold text-[#1a1a1a]" data-id="element-310">{point.bold}</span>{' '}
                  {point.text}
                </p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}